// extracted by mini-css-extract-plugin
export default {"cvError":"X6-z"};